<template>
    <div class="modal-container">
        <div class="selected-product">
            <a href="#" @click.prevent @click="open" v-text="name" data-balloon="Click to see the data sheet"
               data-balloon-pos="up">
            </a>
            <button v-if="showDelete" class="simple" @click="remove"><i class="fa fa-times-rectangle"></i></button>
        </div>
        <div class="remodal" :data-remodal-id='modalID'>
            <div class="modal">
                <object :data="this.result.submittalFile" type="application/pdf" width="100%" height="500px" v-if="active">
                    <p class="meta coach">This browser does not support inline PDFs. Please download the PDF to view it. <a :href="`${this.result.submittalFile}?&download=1`" target="_blank">Download PDF</a></p>
                </object>

            </div>
            <button data-remodal-action="close" class="remodal-close simple"></button>
        </div>
    </div>
</template>

<script>
    import Modal from 'vue/common/_modal'
    import {mapMutations} from 'vuex';

    export default {
        extends: Modal,
        computed: {
          showDelete(){
              return this.$route.name == 'mechanical-browse'
          }
        },
        methods:{
            remove(e) {
                this.removeProduct(this.modalID);
            },

            ...mapMutations('mechanical', [
                'removeProduct',
            ])
        }
    }
</script>
